export default __webpack_public_path__ + "static/media/teachers-and-kids-home_safe.214c963c.jpg";